import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'drug', en);

const UpdateDrugConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Drugs',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.DRUG,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/drug/:id',
      component: React.lazy(() => import('./UpdateDrug')),
    },
  ],
};

export default UpdateDrugConfig;
